export enum PaymentGroupName {
  IDEAL = 'IDEAL_SAFERPAY',
  CREDITCARD = 'CREDITCARD_SAFERPAY',
  PAYPAL = 'PAYPAL_SAFERPAY',
  KLARNA = 'KLARNA',
  REMBOURS = 'REMBOURS', // deprecated
  APPLEPAY = 'APPLEPAY',
  BANCONTACT = 'BANCONTACT',
  BANCONTACT_SAFERPAY = 'BANCONTACT_SAFERPAY',
  CARTE_BLEUE = 'CARTE BLEUE', // deprecated
  APPLEPAY_SAFERPAY = 'APPLEPAY_SAFERPAY',
  GOOGLEPAY_SAFERPAY = 'GOOGLEPAY_SAFERPAY',
  ECOCHEQUE = 'ECOCHEQUE',
}

export enum PaymentProvider {
  SAFERPAY = 'SAFERPAY',
  CLOSEBROTHERS = 'CLOSEBROTHERS', // deprecated
  KLARNA = 'KLARNA',
  WORLDLINE = 'WORLDLINE',
}
